// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.color-primary { color: #2EB6C8; }
.color-secondary { color: #777679; }
.color-gray { color: #8F8F8F; }
.color-outline { color: #D9D9D9; }
.color-background { color: #F2F0F2; }
.color-hc-error { color: #A3030A !important; }

.color-bk-primary { background: #2EB6C8; }
.color-bk-secondary { background: #777679; }
.color-bk-gray { background: #8F8F8F; }
.color-bk-outline { background: #D9D9D9; }
.color-bk-background { background-color: #F2F0F2; }
.color-bk-error { background: #A3030A !important; }
`, "",{"version":3,"sources":["webpack://./src/styles/colors.module.css"],"names":[],"mappings":"AASA,iBAA0B,cAAiB,EAAE;AAC7C,mBAA4B,cAAmB,EAAE;AACjD,cAAuB,cAAc,EAAE;AACvC,iBAA0B,cAAiB,EAAE;AAC7C,oBAA6B,cAAoB,EAAE;AACnD,kBAA2B,yBAA0B,EAAE;;AAEvD,oBAA6B,mBAAsB,EAAE;AACrD,sBAA+B,mBAAwB,EAAE;AACzD,iBAA0B,mBAAmB,EAAE;AAC/C,oBAA6B,mBAAsB,EAAE;AACrD,uBAAgC,yBAA+B,EAAE;AACjE,kBAA2B,8BAA+B,EAAE","sourcesContent":["@value hc-navy: #32445A;\n@value hc-primary: #2EB6C8;\n@value hc-secondary: #777679;\n@value hc-gray: #8F8F8F;\n@value hc-outline: #D9D9D9;\n@value hc-background: #F2F0F2;\n@value hc-error: #A3030A;\n@value hc-orange: #FF8E42;\n\n:global(.color-primary) { color: hc-primary; }\n:global(.color-secondary) { color: hc-secondary; }\n:global(.color-gray) { color: hc-gray; }\n:global(.color-outline) { color: hc-outline; }\n:global(.color-background) { color: hc-background; }\n:global(.color-hc-error) { color: hc-error !important; }\n\n:global(.color-bk-primary) { background: hc-primary; }\n:global(.color-bk-secondary) { background: hc-secondary; }\n:global(.color-bk-gray) { background: hc-gray; }\n:global(.color-bk-outline) { background: hc-outline; }\n:global(.color-bk-background) { background-color: hc-background; }\n:global(.color-bk-error) { background: hc-error !important; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hc-navy": `#32445A`,
	"hcNavy": `#32445A`,
	"hc-primary": `#2EB6C8`,
	"hcPrimary": `#2EB6C8`,
	"hc-secondary": `#777679`,
	"hcSecondary": `#777679`,
	"hc-gray": `#8F8F8F`,
	"hcGray": `#8F8F8F`,
	"hc-outline": `#D9D9D9`,
	"hcOutline": `#D9D9D9`,
	"hc-background": `#F2F0F2`,
	"hcBackground": `#F2F0F2`,
	"hc-error": `#A3030A`,
	"hcError": `#A3030A`,
	"hc-orange": `#FF8E42`,
	"hcOrange": `#FF8E42`
};
export default ___CSS_LOADER_EXPORT___;
